<template>
  <div>
    <Loader v-show="loading" />
    <div class="app-main-layout" v-if="!loading">
      <Navbar @click="isOpen = !isOpen" />
      <Sidebar :open="isOpen" :key="lang"/>

      <main class="app-content" :class="{full: !isOpen}">
        <div class="app-page">
          <router-view />
        </div>
      </main>

      <div class="fixed-action-btn">
        <router-link
          class="btn-floating btn-large blue"
          to="/record"
          v-tooltip="'addNewRecord'"
          :key="$store.getters.info.lang"
        >
          <i class="large material-icons">add</i>
        </router-link>
      </div>
    </div>
  </div>
</template>


<script>
import Navbar from "@/components/app/Navbar.vue";
import Sidebar from "@/components/app/Sidebar.vue";
import messages from "@/plugins/listMessages.js";
import langFilter from "../filters/lang.filter";

export default {
  data: () => ({
      isOpen: true,
      loading: true,
  }),
  components: {
    Navbar,
    Sidebar
  },
  async mounted() {
    if (!Object.keys(this.$store.getters.info).length) {
      await this.$store.dispatch("getInfo");
    }
    this.loading = false;
  },
  computed: {
      lang(){
          return this.$store.getters.info.lang
      },
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {
    error(fbErr) {
      console.log(fbErr);
      this.$error(messages[fbErr.code] || langFilter('smthGoneWrong'));
    }
  }
};
</script>
